import axios from "axios";

export default axios.create({
  baseURL: "/cpoint/app/mbl/",
  headers: {
    "Content-type": "application/json;charset=UTF-8"
  }
});